import { isCSV } from "src/utils/common";
import { SIMULATION_TYPE, EXECUTION_FILE_TYPE } from "src/constant/common";

export const useTabManager = (fileData, serieData, simulationType, executionFileName, isNewVersion, isHasExcelFiles) => {
  const getTabMapping = (fileDataParam) => {
    const data = fileDataParam || fileData;
    const tabs = [];
    let currentId = 1;

    tabs.push({ id: currentId++, type: "main", name: "main_file" });

    if (serieData?.fileResponseLink) {
      tabs.push({ id: currentId++, type: "series", name: "series_response" });
    }

    // 6DOF specific tabs
    if (
      (simulationType === SIMULATION_TYPE["6DOF"] || simulationType === SIMULATION_TYPE["6DOF_MCS"]) &&
      (executionFileName === EXECUTION_FILE_TYPE.MAIN_6DOF ||
        executionFileName === EXECUTION_FILE_TYPE.MCS_6DOF ||
        executionFileName === EXECUTION_FILE_TYPE.DISPERSION_6DOF ||
        executionFileName === EXECUTION_FILE_TYPE.EXPECTED_CASUALTY_6DOF)
    ) {
      if (data?.mass_shape_link) {
        tabs.push({ id: currentId++, type: "6dof", name: "mass_shape" });
      }
      if (data?.wind_model_name) {
        tabs.push({ id: currentId++, type: "6dof", name: "wind_model" });
      }
      if (data?.target_attitude_rate_ascent_name) {
        tabs.push({ id: currentId++, type: "6dof", name: "target_attitude_rate_ascent" });
      }
      if (data?.target_attitude_rate_descent_name) {
        tabs.push({ id: currentId++, type: "6dof", name: "target_attitude_rate_descent" });
      }
      if (data?.target_attitude_ascent_name) {
        tabs.push({ id: currentId++, type: "6dof", name: "target_attitude_ascent" });
      }
      if (data?.target_attitude_descent_name) {
        tabs.push({ id: currentId++, type: "6dof", name: "target_attitude_descent" });
      }
      if (isHasExcelFiles && isHasExcelFiles(data)) {
        tabs.push({ id: currentId++, type: "6dof", name: "excel_files" });
      }
    }

    // 3DOF specific tabs
    if (simulationType === SIMULATION_TYPE["3DOF"]) {
      if (isNewVersion) {
        if (data?.aero_files && Array.isArray(data.aero_files)) {
          data.aero_files
            .filter((aeroFile) => aeroFile?.aero_name && isCSV(aeroFile.aero_name))
            .forEach((aeroFile, index) => {
              tabs.push({ id: currentId++, type: "3dof_aero", name: `aero_file_${index}`, data: aeroFile });
            });
        }
      } else {
        if (data?.aero1_name && isCSV(data?.aero1_name)) {
          tabs.push({ id: currentId++, type: "3dof_aero", name: "aero1" });
        }
        if (data?.aero2_name && isCSV(data?.aero2_name)) {
          tabs.push({ id: currentId++, type: "3dof_aero", name: "aero2" });
        }
      }

      if (data?.wind_model_name) {
        tabs.push({ id: currentId++, type: "3dof", name: "wind_model" });
      }
      if (data?.thrust_profile_name) {
        tabs.push({ id: currentId++, type: "3dof", name: "thrust_profile" });
      }
      if (isHasExcelFiles && isHasExcelFiles(data)) {
        tabs.push({ id: currentId++, type: "3dof", name: "excel_files" });
      }
    }

    if (data?.jsonUpdateContent) {
      tabs.push({ id: currentId++, type: "json_compare", name: "json_compare" });
    }

    return tabs;
  };

  const tabMapping = getTabMapping(fileData);

  const getTabId = (tabName, index = null) => {
    if (index !== null) {
      const tab = tabMapping.find((t) => t.name === `aero_file_${index}`);
      return tab ? tab.id : null;
    }
    const tab = tabMapping.find((t) => t.name === tabName);
    return tab ? tab.id : null;
  };

  return {
    getTabId,
  };
};
